var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8414 3.57812L12.3823 9.002L17.8414 14.4259C17.94 14.2196 17.9999 13.9916 17.9999 13.7481V4.2559C17.9999 4.01237 17.94 3.78439 17.8414 3.57812Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.418 2.67188H1.58207C1.33855 2.67188 1.11056 2.73175 0.904297 2.83043L7.88151 9.77249C8.49843 10.3894 9.50165 10.3894 10.1186 9.77249L17.0958 2.83043C16.8895 2.73175 16.6615 2.67188 16.418 2.67188Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158555 3.57812C0.0598711 3.78439 0 4.01237 0 4.2559V13.7481C0 13.9916 0.0598711 14.2196 0.158555 14.4259L5.61758 9.002L0.158555 3.57812Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6368 9.74219L10.8643 10.5147C9.83634 11.5426 8.16371 11.5426 7.13578 10.5147L6.36332 9.74219L0.904297 15.1661C1.11056 15.2647 1.33855 15.3246 1.58207 15.3246H16.418C16.6615 15.3246 16.8895 15.2647 17.0958 15.1661L11.6368 9.74219Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeMail);
export default __webpack_public_path__ + "static/media/envelope_mail.f369f71177ba33d0a30c29298bb04097.svg";
export { ForwardRef as ReactComponent };